import React from "react";
import images from "../../../utilities/images/images";
import { getExploreHandbookListAnchorId } from "../../DashboardCourses/utils/exploreCoursesScrollRestore";
import { getExploreCardClassName } from "../../DashboardCourses/utils/exploreCardHighlight";
import "../../DashboardCourses/components/dashboardExploreCard.css";
import "./DashboardHandbookCard.css";

const DashboardHandbookCard = ({ book, highlightedAnchorId = null, onOpen, onBuy }) => {
  const hasDiscount =
    Number.parseFloat(book?.price) - Number.parseFloat(book?.discounted_price) !== 0;

  const discountPercent = hasDiscount
    ? 100 -
      Math.round(
        (Number.parseFloat(book?.discounted_price) / Number.parseFloat(book?.price)) * 100
      )
    : null;

  const anchorId = book?.p_id ? getExploreHandbookListAnchorId(book.p_id) : undefined;
  const isSelected = Boolean(anchorId && highlightedAnchorId === anchorId);

  return (
    <article
      className={getExploreCardClassName(
        "dashboard-handbook-card",
        anchorId,
        highlightedAnchorId
      )}
      id={anchorId}
      aria-current={isSelected ? "true" : undefined}
    >
      <div
        className="dashboard-handbook-card__image-wrap"
        onClick={() => onOpen(book)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onOpen(book);
          }
        }}
        role="button"
        tabIndex={0}
      >
        <img src={book?.image} alt="" className="dashboard-handbook-card__image" />
      </div>

      <div className="dashboard-handbook-card__body">
        <h3
          className="dashboard-handbook-card__title dashboard-handbook-card__title--link"
          onClick={() => onOpen(book)}
        >
          {book?.product_name}
        </h3>
        {book?.type ? <span className="dashboard-handbook-card__type">{book.type}</span> : null}

        <div className="dashboard-handbook-card__price-row">
          <strong className="dashboard-handbook-card__price">₹{book?.discounted_price}</strong>
          {hasDiscount ? (
            <div className="dashboard-handbook-card__discount">
              <img src={images.store_offer} alt="" aria-hidden="true" />
              <span>
                <strong>{discountPercent}%</strong> Off
              </span>
            </div>
          ) : null}
        </div>

        {hasDiscount ? (
          <span className="dashboard-handbook-card__strike">₹{book?.price}</span>
        ) : null}
      </div>

      <div className="dashboard-handbook-card__actions">
        <button
          type="button"
          className="dashboard-handbook-card__btn dashboard-handbook-card__btn--outline"
          onClick={(event) => {
            event.stopPropagation();
            onOpen(book);
          }}
        >
          View Details
        </button>
        {!book?.is_subscribe ? (
          <button
            type="button"
            className="dashboard-handbook-card__btn dashboard-handbook-card__btn--primary"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onBuy(book);
            }}
            onMouseDown={(event) => event.stopPropagation()}
          >
            Buy Now
          </button>
        ) : null}
      </div>
    </article>
  );
};

export default DashboardHandbookCard;
